<template>
  <b-modal
    id="preview-video-modal"
    ref="previewVideoModal"
    :cancel-title="$tk('ClientPortal.Form.Actions.Close')"
    cancel-variant="outline-secondary"
    :ok-disabled="true"
    modal-class="no-confirm-button"
    :title="$tk('ClientPortal.Gallery.Videos')"
    size="lg"
    centered
    @cancel="closeVideoPreview"
  >
    <div class="catalog-items mb-0">
      <div class="text-center mb-0">
        <div
          v-if="previewVideo == null"
          class="loading-content text-center"
        >
          <loader
            :size="20"
            :show="saving"
          />
        </div>
        <div v-else>
          <div class="video-ad">
            <video
              id="video"
              ref="videoAdPreview"
              width="100%"
              controls
            />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Hls from 'hls.js'

export default {
  props: {
    videoModel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  mounted() {

  },
  methods: {
    previewVideo() {
      this.$refs.previewVideoModal.show()
      // eslint-disable-next-line func-names
      this.$nextTick(function () {
        this.setVideoSource(this.videoModel.mediaUrl)
      })
    },
    setVideoSource(url) {
      if (Hls.isSupported()) {
        const video = this.$refs.videoAdPreview
        if (url.endsWith('.mp4')) {
          video.src = url
          video.play()
        } else {
          const hls = new Hls()
          hls.loadSource(url)
          hls.attachMedia(video)
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play()
          })
        }
      }
    },

    closeVideoPreview() {
      this.$refs.videoAdPreview.pause()
      this.$refs.previewVideoModal.hide()
    },
  },
}
</script>
